import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageLicense.css"; // পূর্বের গ্লোবাল ডিজাইন থিম বজায় রাখার জন্য

const AddServer = () => {
  const navigate = useNavigate();

  // Form States
  const [formData, setFormData] = useState({
    name: "",
    server_ip: "",
    location: "",
    max_clients: "500", // Default value
    status: "active"    // Default value
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Input Change Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Form Submission Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Basic Validation
    if (!formData.name || !formData.server_ip) {
      setError("Server Name and IP Address are strictly required.");
      return;
    }

    try {
      setLoading(true);
      
      // API Call to Create Server
      const res = await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/server/create",
        formData
      );

      setSuccess("Edge Node registered successfully inside infrastructure!");
      
      // সফলভাবে অ্যাড হওয়ার ২ সেকেন্ড পর ইউজারকে মূল সার্ভার লিস্টে নিয়ে যাবে
      setTimeout(() => {
        navigate("/manage-server");
      }, 2000);

    } catch (err) {
      console.error("Server creation error:", err);
      setError(
        err.response?.data?.message || 
        "Failed to register the node. Please check your backend connection."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="license-table-container">
      
      {/* টপ হেডার / ব্যাক বাটন */}
      <div className="table-header-wrapper" style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "16px" }}>
        <div>
          <h2>Register New Edge Node</h2>
          <p className="subtitle">Connect a new streaming cluster endpoint to the centralized key manager.</p>
        </div>
        <button className="btn-refresh-global" onClick={() => navigate("/manage-server")}>
          ← Back to Nodes
        </button>
      </div>

      {/* ক্রিয়েশন ফর্ম বক্স */}
      <div className="form-card-wrapper">
        
        {/* মেসেজ অ্যালার্ট */}
        {error && <div className="alert-message error-alert">{error}</div>}
        {success && <div className="alert-message success-alert">{success}</div>}

        <form onSubmit={handleSubmit} className="pro-form-layout">
          
          <div className="form-grid-2col">
            {/* Server Name Input */}
            <div className="form-group">
              <label>Server Instance Name <span className="req">*</span></label>
              <input
                type="text"
                name="name"
                placeholder="e.g., US-Edge-Stream-01"
                value={formData.name}
                onChange={handleChange}
                className="search-input form-ctrl"
                required
              />
            </div>

            {/* Server IP Input */}
            <div className="form-group">
              <label>Server IP Address / Domain <span className="req">*</span></label>
              <input
                type="text"
                name="server_ip"
                placeholder="e.g., 192.168.10.25 or edge.domain.com"
                value={formData.server_ip}
                onChange={handleChange}
                className="search-input form-ctrl"
                required
              />
            </div>
          </div>

          <div className="form-grid-3col">
            {/* Location Input */}
            <div className="form-group">
              <label>Geographic Region / Location</label>
              <input
                type="text"
                name="location"
                placeholder="e.g., Singapore, USA, Dhaka"
                value={formData.location}
                onChange={handleChange}
                className="search-input form-ctrl"
              />
            </div>

            {/* Max Client Connections Input */}
            <div className="form-group">
              <label>Max Allowed Connections</label>
              <input
                type="number"
                name="max_clients"
                placeholder="500"
                value={formData.max_clients}
                onChange={handleChange}
                className="search-input form-ctrl"
              />
            </div>

            {/* Node Status Dropdown */}
            <div className="form-group">
              <label>Initial Status State</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="search-input form-ctrl select-ctrl"
              >
                <option value="active">Active / Provisioned</option>
                <option value="inactive">Inactive / Maintenance</option>
              </select>
            </div>
          </div>

          {/* ফর্ম অ্যাকশন বাটনসমূহ */}
          <div className="form-actions-footer">
            <button 
              type="button" 
              className="btn-refresh-global" 
              onClick={() => navigate("/manage-server")}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-add-client" 
              style={{ backgroundColor: "#2563eb", minWidth: "160px", justifyContent: "center" }}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner" style={{ width: "16px", height: "16px", margin: "0 8px 0 0", borderWidth: "2px" }}></div>
              ) : "Deploy Node"}
            </button>
          </div>

        </form>

      </div>

    </div>
  );
};

export default AddServer;